import { BackednResponse } from "@shared/lib/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { PURCHASES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";
import { IPurchases } from "../types";

export interface GetPurchasesParams {
  searchQuery?: string;
  brandIds?: string[];
  briefIds?: string[];
  type?: string[];
  subType?: string[];
  category?: string[];
  createdAtFrom?: string;
  createdAtTo?: string;
  accountingFillingStatus?: string[];
  accountingIds?: string[];
}

export function useGetPurchases(params: GetPurchasesParams) {
  const {
    data,
    isLoading,
    error,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery<BackednResponse<IPurchases>>({
    queryKey: [...PURCHASES_QUERY_KEY, params],
    queryFn: ({ pageParam = 1 }) =>
      AccountingService.getPurchases({
        ...params,
        pageNo: pageParam as number,
        limit: 10,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.data.pagination.hasNextPage) {
        return lastPage.data.pagination.currentPage + 1;
      }
      return undefined;
    },
  });
  const purchases = data?.pages?.flatMap((page) => page.data.data);

  return {
    purchases,
    error,
    isFetching: isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
